import React from 'react';

export interface SegmentedControlOption {
  label: string;
  value: any;
}

export interface SegmentedControlProps {
  options: SegmentedControlOption[];
  value: any;
  onChange: (value: any) => void;
  disabled?: boolean;
  className?: string;
  variant?: 'default' | 'solid';
  fullWidth?: boolean;
}

export const SegmentedControl: React.FC<SegmentedControlProps> = ({
  options,
  value,
  onChange,
  disabled,
  className = "",
  variant = 'default',
  fullWidth = false
}) => {
  const containerClass = variant === 'solid' 
    ? "p-1 bg-white border border-gray-200 rounded-lg items-center" 
    : "p-1 bg-slate-50 border border-gray-200 rounded-lg items-center";

  const flexClass = fullWidth ? "flex w-full" : "inline-flex";

  const getButtonClass = (isActive: boolean) => {
    if (variant === 'solid') {
      return isActive 
        ? "bg-blue-600 text-white shadow-sm" 
        : "text-gray-600 hover:text-gray-900 bg-transparent";
    }
    return isActive 
      ? "bg-white text-blue-600 shadow-sm border border-gray-100" 
      : "text-slate-500 hover:text-slate-700 border border-transparent";
  };

  return (
    <div className={`${flexClass} ${containerClass} ${className}`}>
      {options.map((opt) => {
        const isActive = value === opt.value;
        return (
          <button
            key={String(opt.value)}
            type="button"
            onClick={() => !disabled && onChange(opt.value)}
            disabled={disabled}
            className={`
              px-4 py-1.5 text-sm font-medium rounded-md transition-all whitespace-nowrap
              ${fullWidth ? "flex-1 flex justify-center" : ""}
              ${getButtonClass(isActive)}
              ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
            `}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
};
